<template>
  <page layout="tabbed">
    <page-header-new
      :title="$t('ConsentManager_Title')"
      :breadcrumbs="breadcrumbs"
    >
      <template slot="actions">
        <el-button
          v-if="
            !readonly && $route.name === 'ConsentManagerSubscriptionPreferences'
          "
          type="primary"
          icon="el-icon-plus"
          @click="addSubscriptionPreferenceRow"
        >
          {{ $t('SubscriptionPreferences_Button_Create') }}
        </el-button>
      </template>
    </page-header-new>
    <page-tabs :tabs="availableTabs"></page-tabs>
  </page>
</template>

<script>
import PageHeaderNew from '@/common/components/page/PageHeaderNew'
import Page from '@/common/components/page/Page'
import PageTabs from '@/common/components/page/PageTabs'
import { projectRoute } from '@/core/helpers'
import { EventBus } from '@/core/EventBus'

export default {
  name: 'ConsentManager',
  components: { PageTabs, PageHeaderNew, Page },
  data() {
    return {}
  },
  mounted() {},
  computed: {
    readonly() {
      return !(
        this.$isRole('consent-admin') || this.$can('manageProjectTechnical')
      )
    },
    availableTabs() {
      let tabs = [
        {
          title: this.$t('ConsentManager_ChannelsTab'),
          route: projectRoute({ name: 'ConsentManagerChannels' })
        },
        {
          title: this.$t('ConsentManager_SubscriptionPreferencesTab'),
          route: projectRoute({ name: 'ConsentManagerSubscriptionPreferences' })
        }
      ]

      return tabs
    },
    breadcrumbs() {
      return [
        {
          label: this.$t('ConsentManager_Subscription_Breadcrumb_Main')
        },
        {
          label: this.$t('ConsentManager_Subscription_Breadcrumb_Sub')
        }
      ]
    }
  },
  methods: {
    addSubscriptionPreferenceRow() {
      EventBus.$emit('add-subscription-preference-row')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/consent-manager/pages/ConsentManager.vue